//#region IMPORT
import { useMemo } from 'react';
import { Unstable_Grid2 as Grid } from '@mui/material';
import { AuthButton, Dialog } from '../../../../Components/MUIs';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-enterprise';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import GridFunctions from '../../../../Services/agGrid/ag-Grid-functions';
import { BusinessCommon } from '../../../../Components/BusinessCommon';
import { getColumnDefs1, getColumnDefs2 } from './COM_BASIC_ColumnDefs';
import dayjs from 'dayjs';
//#endregion

const representativeCellStyle = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

function FormatRepresentativeBirth(raw) {
  if (raw == null || raw === '') return '';
  const s = String(raw).trim().replace(/\s+/g, ' ');
  if (/^\d{4}-\d{2}-\d{2}/.test(s)) return s.slice(0, 10);
  const m = s.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})/);
  if (m) {
    const mm = m[1].padStart(2, '0');
    const dd = m[2].padStart(2, '0');
    return `${m[3]}-${mm}-${dd}`;
  }
  const d = dayjs(s);
  return d.isValid() ? d.format('YYYY-MM-DD') : s.slice(0, 16);
}

function NormalizeRepresentativeModalRow(row, displayNo) {
  const coId = row.coId ?? row.CoId ?? '';
  const name = row.name ?? row.Name ?? '';
  const tel = row.tel ?? row.Tel ?? '';
  const birthRaw = row.birth ?? row.Birth ?? '';
  return {
    no: displayNo,
    coId: String(coId),
    name: String(name),
    tel: String(tel).replace(/\s+/g, ' ').trim(),
    birth: FormatRepresentativeBirth(birthRaw),
  };
}

function COM_BASIC(props) {
  const columnDefs1 = getColumnDefs1(props);
  const columnDefs2 = useMemo(
    () => getColumnDefs2({ cellStyle: representativeCellStyle }),
    []
  );

  const representativeModalRows = useMemo(() => {
    const rows = props.modalRowData1 ?? [];
    return rows.map((row, i) =>
      NormalizeRepresentativeModalRow(row, i + 1)
    );
  }, [props.modalRowData1]);

  //#region 함수

  //#endregion

  return (
    <Grid container spacing={2} columns={{ xs: 4, sm: 8, md: 12 }}>
      <Grid xs={4} md={12}>
        <AuthButton
          menuId="Company"
          saveYn={props.userInfo.authCd === 'ADMIN' ? 'Y' : 'N'}
          printYn="N"
          saveClick={() => {
            props.SaveLogic1();
          }}
          searchClick={(e) => {
            props.gridRef1.current.api.setQuickFilter(e);
          }}
          grids={
            <BusinessCommon
              gridId={props.gridId1}
              // rowId 있어야 삭제 로직 정상 작동
              getRowId={(params) => {
                return params.data.no;
              }}
              addYn1={props.userInfo.authCd === 'ADMIN' ? 'Y' : 'N'}
              deleteYn1={props.userInfo.authCd === 'ADMIN' ? 'Y' : 'N'}
              printYn1={'N'}
              addClick1={() => {
                props.HandleAddClick(props.gridRef1);
              }}
              deleteClick1={(e) => {
                const newRowExists = props.selectedRowData.some(
                  (row) => row.newYn === 'Y'
                );

                if (!newRowExists) {
                  props.MarkedForDeletion(props.selectedRowData);
                } else {
                  props.NewYnErrorMsg();
                  props.inputRef.current?.focus();
                }
              }}
              saveClick1={() => props.SaveLogic1()}
              refreshClick1={() => {
                props.SearchLogic1();
              }}
              title1={'회사정보'}
              title2={'회사정보(입력란)'}
              gridRef={props.gridRef1}
              columnDefs={columnDefs1}
              rowData={props.rowData}
              rowSelection="multiple"
              rowMultiSelectWithClick={true}
              setSelectedRowData={props.setSelectedRowData}
              setChangedRowData={props.setChangedRowData}
              tableData={props.tableData}
              colWidth={props.colWidth}
              suppressRowClickSelection={true}
              onCellClicked={(e) => {
                const gridApi = props.gridRef1.current.api;
                const clickedRowIndex = e.rowIndex;

                const isCheckboxClick = e.event?.target?.type === 'checkbox';

                if (!isCheckboxClick) {
                  gridApi.ensureIndexVisible(clickedRowIndex, 'middle');
                  gridApi.setFocusedCell(clickedRowIndex, 'coNm');

                  const copied = JSON.parse(JSON.stringify(e.data));
                  props.handleRowSelection(copied, clickedRowIndex);

                  gridApi
                    .getDisplayedRowAtIndex(clickedRowIndex)
                    ?.setSelected(true, false);
                }
              }}
              onSelectionChanged={() => {
                const gridApi = props.gridRef1?.current?.api;
                const selectedNodes = gridApi.getSelectedNodes();
                const selectedData = selectedNodes.map((n) => n.data);

                props.selectedRowNosRef.current = new Set(
                  selectedData.map((r) => r.no)
                );

                props.setSelectedRowData(selectedData);
              }}
            />
          }
        />
      </Grid>
      {/* 대표자 설정하기 팝업 */}
      {props.modalToggle1 && (
        <div
          role="presentation"
          className="MuiDialog-root MuiModal-root"
          inert="true"
        >
          <Dialog
            title={'대표자 목록'}
            open={props.modalToggle1}
            onClose={(e) => {
              props.setModalToggle1(false);
            }}
            contentSx={{ display: 'flex', flexDirection: 'column' }}
            fullWidth
            saveButtonName={'선택'}
            closeButtonName={'닫기'}
            useSaveButton={true}
            useSaveAfterClose={false}
            maxWidth="md"
            onSave={() => {
              const newCoId = props.selectedModalRowData1[0].coId;
              const newName = props.selectedModalRowData1[0].name;

              const updatedInputs = {
                ...props.inputs,
                coId: newCoId,
                name: newName,
              };

              props.setInputs(updatedInputs);

              props.updateCurrentRowData('coId', newCoId, true);
              props.updateCurrentRowData('name', newName, true);

              GridFunctions.formGridState(
                props.gridRef1,
                'name',
                newName,
                updatedInputs
              );
              GridFunctions.formGridState(
                props.gridRef1,
                'coId',
                newCoId,
                updatedInputs
              );

              props.setModalToggle1(false);

              setTimeout(() => {
                props.inputRef2.current?.focus();
                props.setFocusEnabled(true);
              }, 0);
            }}
            content={
              <div
                className="ag-theme-alpine no-scroll"
                style={{ height: '600px', width: '100%' }}
              >
                <AgGridReact
                  ref={props.gridRef2}
                  animationRows={true}
                  columnDefs={columnDefs2}
                  rowData={representativeModalRows}
                  getRowId={(p) =>
                    `rep-${p.data?.no ?? p.rowIndex}-${p.data?.coId ?? ''}`
                  }
                  defaultColDef={{
                    minWidth: 100,
                    editable: false,
                    resizable: true,
                    sortable: true,
                    filter: true,
                    floatingFilter: true,
                    wrapText: false,
                    autoHeight: false,
                  }}
                  rowSelection="single"
                  onSelectionChanged={() => {
                    GridFunctions.onSelectionChanged(
                      props.gridRef2,
                      (_selected) => {
                        props.setSelectedModalRowData1(_selected);
                      }
                    );
                  }}
                  getRowStyle={(e) => GridFunctions.getRowStyle(e)}
                />
              </div>
            }
          />
        </div>
      )}
    </Grid>
  );
}

export default COM_BASIC;
